import { mergeAttributes } from '@tiptap/core';
import { Table, createColGroup } from '@tiptap/extension-table';
const TuiTable = Table.extend({
  renderHTML({
    node,
    HTMLAttributes
  }) {
    const {
      colgroup,
      tableWidth,
      tableMinWidth
    } = createColGroup(node, this.options.cellMinWidth);
    return ['div', {
      class: 'tui-table-wrapper'
    }, ['table', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
      style: tableWidth ? `width: ${tableWidth}` : `min-width: ${tableMinWidth}`
    }), colgroup, ['tbody', 0]]];
  }
}).configure({
  resizable: true,
  lastColumnResizable: false,
  allowTableNodeSelection: true
}).extend();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiTable };
